// To do:
// - If we keep this page concept then move all content to data files & have page dynamically render based upon area, etc.


import { useNavigate } from 'react-router-dom'; // Import useNavigate hook from react-router-dom
import { PageHeader, Page, PageContent, Heading, Box, Text, Button, Card, CardHeader, CardBody, CardFooter } from 'grommet';
import { CircleInformation as InfoIcon, ShareOption as ShareIcon, Add as AddIcon } from 'grommet-icons';

export const RoadmapSummary = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook

  // Handle button clicks to navigate programmatically using React Router
  const handleNavigate = (path) => {
    navigate(path); // Navigate to the specified path
  };

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('/images/home-banner.png')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader 
            pad={{ top: '15px', bottom: '15px' }} 
            title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Route to Market Road Map Overview</Text>} 
            subtitle={'Top initiatives and road map priorities.'}
            style={{ color: 'black' }}
            size='medium'
          />
          <Box width="small">
            <Button 
              label="View full Road Map" 
              primary 
              size="medium" 
              onClick={() => handleNavigate('/roadmap-display')} // Use onClick to navigate
            />
          </Box>
        </Box>                  
      </Box> 

      <PageContent flex="grow">
        <Heading size="large" weight="bold" margin={{ top: 'large' }}>Top Road Map Priorities</Heading>

        <Heading size="medium" margin={{ top: 'medium', bottom: 'xsmall' }}>Sales - Increase Revenue</Heading>
        <Text size="large">Deliver automated instant pricing and new operations console.</Text>
        <Box direction="row">
          <Card height="small" width="medium" background="light-1" margin={{ top: 'medium', bottom: 'medium', right: 'medium', left: 'none' }}>
            <CardHeader pad="small">
              <Box direction="row" align="center">
                <AddIcon color="purple"/>
                <Text weight="bold" margin={{ left: 'small' }} align="center">Intelligent Automated Pricing (IAP)</Text>
              </Box>
            </CardHeader>
            <CardBody pad="small">Deliver a step change delivering HPE's "best price" upfront in realtime. Enablement will in part leverage a new pricing AI foundation with Pros Gen4.</CardBody>
            <CardFooter pad={{horizontal: "small"}} background="light-2">
              <Button tip="Display fact sheet" icon={<InfoIcon color="brand" />} hoverIndicator/>
              <Button tip="Share" icon={<ShareIcon color="plain" />} hoverIndicator />
            </CardFooter>
          </Card>
          <Card height="small" width="medium" background="light-1" margin={{ top: 'medium', bottom: 'medium', right: 'medium', left: 'none' }}>
            <CardHeader pad="small">
              <Box direction="row" align="center">
                <AddIcon color="purple"/>
                <Text weight="bold" margin={{ left: 'small' }} align="center">Pricing Operations Console</Text>
              </Box>
            </CardHeader>
            <CardBody pad="small">Delivers a single pane of glass for pricing administrators to view live operational health, tune pricing guidance logic and manage HPE's pricing and margins.</CardBody>
            <CardFooter pad={{horizontal: "small"}} background="light-2">
              <Button tip="Display fact sheet" icon={<InfoIcon color="brand" />} hoverIndicator/>
              <Button tip="Share" icon={<ShareIcon color="plain" />} hoverIndicator />
            </CardFooter>
          </Card>            
        </Box>
        <Box width="small" margin={{ top: 'medium' }}>
          <Button 
            label="Show on Road Map" 
            size="medium" 
            onClick={() => handleNavigate('/roadmap-display')} // Use onClick to navigate
          />
        </Box>

        <Heading size="medium" margin={{ top: 'large', bottom: 'xsmall' }}>Marketing - Increase Intelligence & Campaign Effectiveness</Heading>
        <Text size="large">Deliver new intelligent insights and data platform to drive deeper customer intelligence and targeting.</Text>
        <Box direction="row">
          <Card height="small" width="medium" background="light-1" margin={{ top: 'medium', bottom: 'medium', right: 'medium', left: 'none' }}>
            <CardHeader pad="small">
              <Box direction="row" align="center">
                <AddIcon color="purple"/>
                <Text weight="bold" margin={{ left: 'small' }} align="center">New City Data Platform for Marketing</Text>
              </Box>
            </CardHeader>
            <CardBody pad="small">Phase 1 delivery of critical marketing data products on HPE's new Data Platform, all operations readiness (business & IT) and first set of modern analytics deployed.</CardBody>
            <CardFooter pad={{horizontal: "small"}} background="light-2">
              <Button tip="Display fact sheet" icon={<InfoIcon color="brand" />} hoverIndicator/>
              <Button tip="Share" icon={<ShareIcon color="plain" />} hoverIndicator />
            </CardFooter>
          </Card>
          <Card height="small" width="medium" background="light-1" margin={{ top: 'medium', bottom: 'medium', right: 'medium', left: 'none' }}>
            <CardHeader pad="small">
              <Box direction="row" align="center">
                <AddIcon color="purple"/>
                <Text weight="bold" margin={{ left: 'small' }} align="center">Marketing Agentic AI Enablement</Text>
              </Box>
            </CardHeader>
            <CardBody pad="small">Phase 1 Agentic enablement to drive real-time, intelligent and autonomous tuning of marketing campaigns to deliver a step change in campaign context tuning and outcome success.</CardBody>
            <CardFooter pad={{horizontal: "small"}} background="light-2">
              <Button tip="Display fact sheet" icon={<InfoIcon color="brand" />} hoverIndicator/>
              <Button tip="Share" icon={<ShareIcon color="plain" />} hoverIndicator />
            </CardFooter>
          </Card>            
        </Box>
        <Box width="small" margin={{ top: 'medium' }}>
          <Button 
            label="Show on Road Map" 
            size="medium" 
            onClick={() => handleNavigate('/roadmap-display')} // Use onClick to navigate
          />
        </Box>
      </PageContent>  

    </Page>
  );
};
